// Row 4.6 — maintenance-mode signal. One flag key, one place. Rides the existing in-DB flag
// system (FlagsContext, fail-open): until a `maintenance_mode` flag row is configured
// server-side the hook resolves false and the system is behavior-neutral (CFR: flag seeding
// + admin surface are backend work, not this batch).
import { useFlag } from "../flags/FlagsContext";

export const MAINTENANCE_FLAG_KEY = "maintenance_mode";

export function useMaintenanceMode(): boolean {
  return useFlag(MAINTENANCE_FLAG_KEY, false);
}
